// Reconhecer um cliente pelo nome escrito: nome da ficha, outros nomes (marcas, siglas, empresas do grupo)
// ou designação fiscal de uma entidade de faturação. Ex.: «E-Redes» → EDP, «BCM» → Leroy Merlin.
export const nk = (t) => String(t ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
  .replace(/\b(s\.?a\.?|lda\.?|unipessoal|sucursal|sgps|ace)\b/g, ' ').replace(/[^a-z0-9]+/g, '');

export async function encontrarCliente(supabase, texto) {
  const alvo = nk(texto);
  if (alvo.length < 2) return null;
  const [{ data: clis }, { data: ents }] = await Promise.all([
    supabase.from('clientes').select('id,nome,outros_nomes'),
    supabase.from('entidades_faturacao').select('cliente_id,designacao_fiscal').eq('ativo', true),
  ]);
  const porId = Object.fromEntries((clis || []).map(c => [String(c.id), c]));
  for (const c of (clis || [])) {
    if (nk(c.nome) === alvo) return { id: c.id, nome: c.nome, via: 'nome' };
  }
  for (const c of (clis || [])) {
    const o = (c.outros_nomes || []).find(n => nk(n) === alvo);
    if (o) return { id: c.id, nome: c.nome, via: o };
  }
  for (const e of (ents || [])) {
    const c = porId[String(e.cliente_id)];
    if (c && nk(e.designacao_fiscal) === alvo) return { id: c.id, nome: c.nome, via: e.designacao_fiscal };
  }
  return null;
}
